export default __webpack_public_path__ + "media/images/file_types/jpeg-46fc91df08c63942083cb6d5ee44f73e.svg";